<template>
  <div class="home">
    <Header
      @routerEvent="layoutEvent"
      @logout="logout"
      v-if="extras && seminarInfo"
      :loginUrl="loginUrl"
      :registerUrl="registerUrl"
      :extras="extras"
      :seminarInfo="seminarInfo"
      :memberInfo="memberInfo"
    />
    <Banner
      v-if="extras && seminarInfo"
      :seminarInfo="seminarInfo"
      :memberInfo="memberInfo"
      :isFrozen="isFrozen"
      :signUpStatus="signUpStatus"
      :loginUrl="loginUrl"
      :registerUrl="registerUrl"
      :extras="extras"
    />
    <Suspension
      ref="suspension"
      v-if="extras && memberInfo && seminarInfo"
      :extras="extras"
      :isFrozen="isFrozen"
      :signUpStatus="signUpStatus"
      :seminarInfo="seminarInfo"
      :markCode="markCode"
      :memberInfo="memberInfo"
    />
    <Introduction
      v-if="extras && seminarInfo"
      :seminarInfo="seminarInfo"
      :extras="extras"
    />
    <GuestInfo
      v-if="extras && seminarInfo"
      :guests="seminarInfo.guests"
      :extras="extras"
    />
    <Schedule
      v-if="extras && seminarInfo"
      :agendas="seminarInfo.agendas"
      :extras="extras"
    />
    <NewInfo v-if="extras && newsInfo" :newsInfo="newsInfo" :extras="extras" />
    <Partner
      @partnerDetailClick="partnerDetailClick"
      v-if="extras && partnerInfo"
      :partnerInfo="partnerInfo"
      :extras="extras"
    />
    <DownloadInfo
      v-if="extras && fileInfo"
      :seminarInfo="seminarInfo"
      :memberInfo="memberInfo"
      :fileInfo="fileInfo"
      :extras="extras"
    />
    <popup
      @PopupClose="PopupClose"
      class="m-pop"
      v-if="popupData.popupShow"
      :popupInfo="popupData.popupInfo"
    ></popup>
    <div class="m-footer">©2022 Sinobase Marketing Technology Corpo</div>
  </div>
</template>

<script>
import Header from "@/components/wap/Header.vue";
import Introduction from "@/components/wap/Introduction.vue";
import Schedule from "@/components/wap/Schedule.vue";
import GuestInfo from "@/components/wap/GuestInfo.vue";
import NewInfo from "@/components/wap/NewInfo.vue";
import DownloadInfo from "@/components/wap/DownloadInfo.vue";
import Partner from "@/components/wap/Partner.vue";
import Banner from "@/components/wap/Banner.vue";
import Popup from "../../components/wap/Popup";
import Suspension from "@/components/wap/Suspension.vue";
import Api from "../../service/api";
import { URLS } from "fire-wind-water";
import templateMixin from "../../mixins/seminar-config";
import seminarMixin from "../../mixins/seminar";

export default {
  name: "Index",
  data() {
    return {
      fileInfo: null,
      newsInfo: null,
      partnerInfo: null,
      popupData: {
        popupShow: false,
        popupInfo: null,
      },
      isMobile: !!navigator.userAgent.match(/(iPhone|iPod|Android|ios)/i),
    };
  },
  components: {
    Header,
    Introduction,
    Schedule,
    GuestInfo,
    NewInfo,
    DownloadInfo,
    Partner,
    Banner,
    Popup,
    Suspension,
  },
  mixins: [templateMixin, seminarMixin],
  created() {
    window.$sk.loading.show();
    this.initPage();
  },
  computed: {
    loginUrl: function () {
      if (URLS.getURL("isSetting") == 1) {
        return "";
      }
      if (this.handleBackUrl && this.seminarInfo) {
        return this.handleBackUrl(this.seminarInfo.login);
      } else {
        return "";
      }
    },
    registerUrl: function () {
      if (URLS.getURL("isSetting") == 1) {
        return "";
      }
      if (this.handleBackUrl && this.seminarInfo) {
        return this.handleBackUrl(this.seminarInfo.register);
      } else {
        return "";
      }
    },
  },
  methods: {
    async initPage() {
      const instanceId = URLS.getURL("instanceId");
      let info = window.$sk.template.get();
      const { globalUserId } = info.user;
      await Api.getArticleList({
        instanceId,
        globalUserId,
        type: "news", //新闻资讯
      }).subscribe((newsInfoRes) => {
        this.newsInfo = newsInfoRes.content;
      });

      await Api.getArticleList({
        instanceId,
        globalUserId,
        type: "partner", //合作伙伴
      }).subscribe((partnerInfoRes) => {
        this.partnerInfo = partnerInfoRes.content;
      });

      await Api.getFileList({
        instanceId,
        globalUserId,
      }).subscribe((FileRes) => {
        this.fileInfo = FileRes.content;
      });
      /*window.$sk.loading.hide();*/
    },
    partnerDetailClick(e) {
      let popupData = {
        popupShow: true,
        popupInfo: e,
      };
      this.popupData = popupData;
    },
    PopupClose() {
      let popupData = {
        popupShow: false,
        popupInfo: null,
      };
      this.popupData = popupData;
    },
    logout() {
      const info = window.$sk.template.get();
      info.cookie.removeSession();
      this.$refs.suspension.clearSession();
      this.memberInfo = {
        name: "",
        headImg: "",
        signUpStatus: 0,
      };
    },
    handleBackUrl: function (url) {
      if (!url) {
        return "";
      } else {
        let _url = "";
        const hasBackUrl = url.indexOf("backUrl");
        if (hasBackUrl !== -1) {
          _url =
            url.slice(0, hasBackUrl - 1) +
            "&backUrl=" +
            encodeURIComponent(location.href);
        } else {
          _url = url + "&backUrl=" + encodeURIComponent(location.href);
        }
        return _url;
      }
    },
    downloadEvent(mailbox, fileList) {
      const instanceId = URLS.getURL("instanceId");
      const { globalUserId } = this.template.user;
      Api.getDownloadWithEmail({
        instanceId,
        email: mailbox,
        globalUserId,
        moduleType: 3,
        fileList: fileList,
      }).subscribe(() => {});
    },
    layoutEvent(item) {
      let items = document.querySelectorAll(".top-nav");
      for (let i = 0; i < items.length; i++) {
        document.getElementById(item.key).scrollIntoView({
          block: "center", //默认跳转到顶部
          behavior: "smooth", //滚动的速度
        });
      }
    },
    hideBox(e) {
      let isBox = false;
      if (e && e.path) {
        e.path.forEach((path) => {
          if (path.className) {
            let className = path.className.toString();
            if (className.indexOf("m-qrcode") >= 0) {
              isBox = true;
            }
          }
        });
        if (!isBox) {
          this.$refs.suspension.closeBox();
        }
      }
    },
  },
};
</script>
<style scoped lang="scss"></style>
